<nav class="bottom-navbar" [class.header-toggled]="navServices.collapseSecondHeader">
  <div class="container">
    <ul class="nav page-navigation">
      <li style="width: 180px;" class="nav-item" [class.active]="currentParrent ==='dashboard' && currentChild === ''">
        <a [routerLink]="'/' + BRAND.BASE_ROUTE+ '/dashboard'" class="nav-link">
          <i class="mdi mdi-grid menu-icon"></i>
          <span class="menu-title">Home</span>
          <i class="menu-arrow"></i>
        </a>
      </li>
      <li style="width: 180px;" class="nav-item" [class.active]="currentParrent ==='order'">
        <a class="nav-link" [routerLink]="USER_TYPE && USER_TYPE === 'CUSTOMER'? ['/' + BRAND.BASE_ROUTE+ '/order/addOrderRequisitions'] : ['/' + BRAND.BASE_ROUTE+ '/order/viewOrderRequistions']">
          <i class="mdi mdi-file-document-box menu-icon"></i>
          <span class="menu-title">My Orders</span>
          <i class="menu-arrow"></i>
        </a>
        <div style="width: 100%;" class="submenu">
          <ul>
            <li *ngIf="USER_TYPE && USER_TYPE === 'CUSTOMER'" class="nav-item" [class.active]="currentChild==='addOrderRequisitions'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/addOrderRequisitions']">Place an Order</a>
            </li>
            <li *ngIf="USER_TYPE && USER_TYPE === 'CUSTOMER'" class="nav-item " [class.active]="currentChild==='salesOrder'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/salesOrder']">Approve PI's</a>
            </li>
            <li class="nav-item " [class.active]="currentChild==='viewOrderRequistions'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/viewOrderRequistions']">Review an Order</a>
            </li>
            <li *ngIf="USER_TYPE && USER_TYPE === 'CUSTOMER'" class="nav-item " [class.active]="currentChild==='modifyOrder'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/modifyOrder']">Modify an Order</a>
            </li>
            <li class="nav-item " [class.active]="currentChild==='pendingOrder'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/pendingOrder']">Pending Orders</a>
            </li>
            <li class="nav-item " [class.active]="currentChild==='pastOrder'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/pastOrder']">Past Orders</a>
            </li>
            <li *ngIf="USER_TYPE && USER_TYPE === 'OM'" class="nav-item " [class.active]="currentChild==='assignOrder'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/assignOrder']">Assign Organization</a>
            </li>
            <!-- <li class="nav-item">
                            <a class="nav-link" href="orderrequisitions.html">  Order Requisitions</a>
                          </li> -->
          </ul>
        </div>
      </li>
      <li style="width: 180px;" class="nav-item" [class.active]="currentParrent ==='packing'">
        <a [routerLink]="['/' + BRAND.BASE_ROUTE+ '/packing/viewArtwork']" class="nav-link">
          <i class="mdi mdi-cube-outline menu-icon"></i>
          <span class="menu-title">My Artwork</span>
          <i class="menu-arrow"></i>
        </a>
        <div style="width: 100%;" class="submenu">
          <ul>
            <li [class.active]="currentChild==='viewArtwork'" class="nav-item"><a class="nav-link"
                [routerLink]="['/' + BRAND.BASE_ROUTE+ '/packing/viewArtwork']">View Artwork</a></li>
            <li *ngIf="USER_TYPE && USER_TYPE === 'CUSTOMER'" class="nav-item" [class.active]="currentChild==='artworkRequest'"><a class="nav-link"
                [routerLink]="['/' + BRAND.BASE_ROUTE+ '/packing/artworkRequest']">Request Artwork</a></li>
            <li *ngIf="USER_TYPE && (USER_TYPE === 'SALES' || USER_TYPE === 'CC')" class="nav-item" [class.active]="currentChild==='uploadArtwork'"><a class="nav-link"
                [routerLink]="['/' + BRAND.BASE_ROUTE+ '/packing/uploadArtwork']">Upload Artwork Proof</a></li>
            <li *ngIf="USER_TYPE && USER_TYPE === 'CUSTOMER' && ARTWORK_APPROVE_FLAG === 'Y'" class="nav-item" [class.active]="currentChild==='approveArtwork'"><a class="nav-link"
                [routerLink]="['/' + BRAND.BASE_ROUTE+ '/packing/approveArtwork']">Approve Artwork</a></li>
          </ul>
        </div>
      </li>
      <li style="width: 180px;" class="nav-item" [class.active]="currentParrent ==='finance'">
        <a [routerLink]="['/' + BRAND.BASE_ROUTE+ '/finance/aging']" class="nav-link">
          <i class="mdi mdi-chart-areaspline menu-icon"></i>
          <span class="menu-title">My Payments</span>
          <i class="menu-arrow"></i>
        </a>
        <div style="width: 100%;" class="submenu">
          <ul>
            <li class="nav-item" [class.active]="currentChild==='aging'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/finance/aging']">Upcoming & Overdue</a>
            </li>
            <li class="nav-item" [class.active]="currentChild==='payment'">
              <a class="nav-link" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/finance/payment']">Past Payments</a>
            </li>
          </ul>
        </div>
      </li>
      <li style="width: 180px;" class="nav-item" [class.active]="currentParrent ==='dashboard' && currentChild === 'contact'">
        <a [routerLink]="['/' + BRAND.BASE_ROUTE+ '/dashboard/contact']" class="nav-link">
          <i class="mdi mdi-phone menu-icon"></i>
          <span class="menu-title">My Messages</span>
          <i class="menu-arrow"></i>
        </a>
      </li>
    </ul>
  </div>
</nav>